import { HelmetDexteel } from "@dexteel/mesf-core";
import { RecipesManager } from "./components/RecipesManager";

export const RecipesPage = () => {
	return (
		<>
			<HelmetDexteel title="Recipes" />
			<RecipesManager />
		</>
	);
};
